import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "text-area-standard-box" }
const _hoisted_2 = { class: "wrapper" }
const _hoisted_3 = ["disabled", "placeholder"]

import { ref, watch, onMounted } from 'vue'
interface EMITS {
  (e: 'emitInput', inputValue: string | number): void
  (e: 'emitBlur'): void
}

export default /*@__PURE__*/_defineComponent({
  __name: 'TextAreaStandard',
  props: {
  disabled: { type: Boolean, default: false },
  error: { type: Boolean, default: false },
  errorMessage: { type: String, default: '' },
  helpText: { type: String, default: '' },
  hideIconX: { type: Boolean, default: false },
  label: { type: String, default: '' },
  placeHolderText: { type: String, default: '' },
  prefilledText: { type: String, default: '' },
  success: { type: Boolean, default: false },
  infoText: { type: String, default: '' }
},
  emits: ["emitInput", "emitBlur"],
  setup(__props, { emit: __emit }) {

const props = __props
const emits = __emit
const textAreaRef = ref<HTMLElement | null>(null)
const inputValue = ref<string | number>('')
const prefilledText = ref<string>(props.prefilledText)
const showIconXValue = ref<string>('')

function emitInputValue() {
  emits('emitInput', inputValue.value)
}
function showIconX() {
  showIconXValue.value = 'show'
}
watch(inputValue, (newVal) => {
  if (typeof newVal === 'string' && newVal.length >= 1 && !props.hideIconX) showIconX()
})
if (prefilledText.value?.length) inputValue.value = prefilledText.value
watch(prefilledText, (newVal) => {
  if (newVal?.length) inputValue.value = newVal
})
onMounted(() => {
  if (prefilledText.value?.length) inputValue.value = prefilledText.value
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["text-area-standard-box__label", { 'text-area-standard-box__label__disabled': __props.disabled }])
    }, _toDisplayString(__props.label), 3),
    _createElementVNode("div", _hoisted_2, [
      _withDirectives(_createElementVNode("textarea", {
        ref_key: "textAreaRef",
        ref: textAreaRef,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((inputValue).value = $event)),
        class: _normalizeClass(["text-area-standard", {
          'text-area-standard__disabled': __props.disabled,
          'text-area-standard__error': __props.error,
          'text-area-standard__success': __props.success
        }]),
        disabled: __props.disabled,
        placeholder: __props.placeHolderText,
        onBlur: _cache[1] || (_cache[1] = ($event: any) => (emits('emitBlur'))),
        onInput: emitInputValue
      }, null, 42, _hoisted_3), [
        [_vModelText, inputValue.value]
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["text-area-standard-box__help-text", {
        'text-area-standard-box__help-text__disabled': __props.disabled,
        'text-area-standard-box__help-text__error': __props.error,
        'text-area-standard-box__help-text__success': __props.success
      }])
    }, _toDisplayString(__props.error ? __props.errorMessage : __props.helpText), 3)
  ]))
}
}

})